import { ActionType } from "../actions/ActionTypes";

export interface FeedbackState {
  error: string;
  loading: boolean;
  message: string;
}

const initialState: FeedbackState = {
  error: "",
  loading: false,
  message: "",
};

const reducer = (state: object = initialState, action: any): any => {
  switch (action.type) {
    case ActionType.INTEREST_MODAL_SUBMIT_INIT:
      return {
        ...state,
        loading: true,
        error: "",
        message: "",
      };
    case ActionType.INTEREST_MODAL_SUBMIT_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload.message || "Interest submitted successfully",
      };
    case ActionType.INTEREST_MODAL_SUBMIT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        message: action.payload.message || "Error submitting interest",
      };

    default:
      return state;
  }
};

export default reducer;
